// 日历
import { PresetModal, WeekDay } from "./context"
import { PresetPlace } from "Types/place"
import { PresetBoard } from "Types/board"
import { useAssign } from "Hooks/basic"
import { usePresetHasura, useSubscriptionPreset } from "Hooks/preset"
import { useFetchArticleType } from "Hooks/article"
import { useEffect } from "react"

export function useCalendar() {
    // 日历横轴（星期
    const weekDays: WeekDay[] = []
    for (let i = 0; i <= 6; i++) {
        weekDays.push({
            text: `星期${"一二三四五六日".charAt(i)}`,
            day: i,
        })
    }
    // 日历纵轴（点位
    const sidePlaces: PresetPlace[] = []
    const hourArr = ["12:00", "16:00", "20:00"]
    for (let i = 1; i <= 15; i++) {
        sidePlaces.push({
            seq_id: i,
            name: `${hourArr[Math.floor((i - 1) / 5)]} (${(i % 5) || 5}条)`,
        })
    }
    // 日历内容
    const { preset } = useSubscriptionPreset()
    const calendarData = preset.reduce((acc: { [key: string]: PresetBoard }, item: PresetBoard) => {
        const { seq_id, ad_weekday } = item
        acc[`${ad_weekday}${seq_id}`] = item
        return acc
    }, {})
    // 日历弹窗
    const { object: presetModal, handleChange: setPresetModal } = useAssign<PresetModal | null>(null)
    // 弹窗可选文章类型 (全部类型)
    const { articleTypes, fetchArticleTypes } = useFetchArticleType()
    // preset hasura方法
    const { createPreset, updatePreset, deletePreset } = usePresetHasura()
    useEffect(() => {
        fetchArticleTypes()
        // eslint-disable-next-line
    }, [])
    return {
        weekDays,
        sidePlaces,
        calendarData,
        presetModal,
        setPresetModal,
        articleTypes,
        createPreset,
        updatePreset,
        deletePreset,
    }
}
